'use server'

export async function getCategoriesByUrl(categoryUrlId: string) {
    try {
          const baseUrl = process.env.API_URL_CATEGORIES
                  if (!baseUrl) {
            console.warn(
                '[getCategoriesByUrl] ENV API_URL_CATEGORIES is missing'
            )
            return []
        }

        if (!categoryUrlId) {
            console.warn(
                '[getCategoriesByUrl] categoryUrlId is missing'
            )
            return []
        }


        const res = await fetch(
            `${baseUrl}/url/${categoryUrlId}`,
            {
                next: { revalidate: 0 },
            },
        )
               if (!res.ok) {
            console.warn(
                '[getCategoriesByUrl] HTTP error:',
                res.status,
                res.statusText,
            )
             return []
        }

         const contentType = res.headers.get('content-type')

        if (!contentType?.includes('application/json')) {
            console.warn(
                '[getCategoriesByUrl] Ответ не в формате JSON:',
                contentType
            )


            const text = await res.text()
            console.warn('[getCategoriesByUrl] Ответ сервера на запрос категории по ID:', text.slice(0, 200))

            return []
        }
         const data = await res.json()
        
        return data
    } catch (err) {
        console.error(err)
        return []
    }
}

export async function getCategories() {
    try {
        const url = process.env.API_URL_CATEGORIES

            if (!url) {
            console.error('[getCategories] ENV API_URL_CATEGORIES неверные данные')
            return []
        }

        const res = await fetch(url, {
            next: { revalidate: 0 },
        })

        if (!res.ok) {
            console.warn(
                '[getCategories] HTTP error:',
                res.status,
                res.statusText,
            )
             return []
        }

         const contentType = res.headers.get('content-type')

        if (!contentType?.includes('application/json')) {
            console.warn(
                '[getCategories] Ответ не в формате JSON:',
                contentType
            )

            // читаем как текст ТОЛЬКО для логов
            const text = await res.text()
            console.warn('[getCategories] Ответ сервера на запрос категорий:', text.slice(0, 200))

            return []
        }
        const data = await res.json()

       
         return data
    } catch (err) {
        console.error('[getCategories] Fetch failed:', err)
        return []
    }
}

export async function getSubcategoriesByCurrentCategory(
    categoryID: string | number | null,
) {
     if (categoryID == null) {
        console.warn('[getSubcategories] categoryID is null')
        return null
    }

    const url = `${process.env.API_URL_CATEGORIES}/${categoryID.toString()}`
    try {
        console.log(categoryID, 'ttyt')
        const res = await fetch(
            url,{ next: { revalidate: 0 } }
        )
        if (!res.ok) {
            console.warn('[getSubcategories] HTTP error:', res.status, res.statusText)
            return null
        }
           const contentType = res.headers.get('content-type')
        if (!contentType?.includes('application/json')) {
            const text = await res.text()
            console.warn('[getSubcategories] Response is not JSON:', text.slice(0, 200))
            return null
        }

        const data = await res.json()
        return data
    } catch (err) {
      console.error('[getSubcategories] fetch failed:', err)
    }
}

